import { render } from "./create-client.vue?vue&type=template&id=db499b3a&scoped=true&ts=true"
import script from "./create-client.vue?vue&type=script&lang=ts"
export * from "./create-client.vue?vue&type=script&lang=ts"

import "./create-client.vue?vue&type=style&index=0&id=db499b3a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db499b3a"]])

export default __exports__